<template>
  <div>
    <h1>글쓰기</h1>
    <b-container fluid>
      <b-row class="my-1">
        <b-col sm="2">
          <label for="input-default">제목:</label>
        </b-col>
        <b-col sm="10">
          <b-form-input id="input-default" ref="title" placeholder="제목을 입력하세요." v-model="title"></b-form-input>
        </b-col>
        <b-col sm="2">
          <label for="input-default">내용:</label>
        </b-col>
        <b-col sm="10">
          <vue-editor 
            id="editor"
            useCustomImageHandler
            @image-added="handleImageAdded" 
            v-model="content" />
        </b-col>
        <b-form-file
          v-model="file1"
          :state="Boolean(file1)"
          accept=".jpg, .png, .gif"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
      </b-row>
      <b-button variant="outline-primary" @click="noticeSubmit">저장하기</b-button>
    </b-container>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import axios from 'axios'


export default {
  name : 'Vueeditor',
  components:{
    VueEditor 
  },
  data(){
    return {
      title: "",
      content: "",
      idx : "",
      file1 : null
    }
  },
  computed: {
      check_completeHidden(){
        return this.$store.state.modal.completeHiddenYn;
      }
    },
    watch: {
      check_completeHidden(val) {
        if(val === "Y"){
          this.$nextTick(() => {
            let focusItem = this.$store.state.modal.focusItem;
            this.$refs[focusItem].focus()
          })
        }
      }
    },
  methods:{
    boardSampleSubmit(){
      if(!this.title){
        this.$alert("알림", "제목을 입력해주세요.");
        return false;
      }

      if(!this.content){
        this.$alert("알림", "내용을 입력해주세요.");
        return false;
      }

      //let paramDatas = { idx: this.idx, title : this.title, content : this.content };
      let title = this.title;
      let content = this.content;
      axios.post('http://localhost:8080/test/noticeSampleSubmit', null, { params: {
        title,
        content
      }})
      .then(response => {
          if(response.status == 200){
            alert("저장 성공");
            this.$router.go();
          }
      })
      .catch(() => {
      })
      .then(() => {
      });
    },
    noticeSubmit(){
      if(!this.title){
        alert("제목을 입력해주세요.");
        return false;
      }

      if(!this.content){
        alert("내용을 입력해주세요.");
        return false;
      }

      const formData = new FormData();
      formData.append("uploadFile", this.file1);
      formData.append("title", this.title);
      formData.append("content", this.content);

      axios.post('http://localhost:8080/test/noticeFileSubmit', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })  
      .then(() => {
        alert("저장 성공");
        this.$router.go();
      })
      .catch(() => {
      });
      /* axios.post('http://localhost:8080/test/noticeSubmit',  paramDatas)
      .then(response => {
          if(response.status == 200){
            alert("저장 성공");
            this.$router.go();
          }
      })
      .catch(() => {
      })
      .then(() => {
      }); */
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("image", file);

     axios({
        url: "http://localhost:8080/api/file/imageUpload",
        method: "POST",
        data: formData
      })
      .then(result => {
        let url = `http://localhost:8080/api/file/previewImage?path=${result.data.URL}`;
        Editor.insertEmbed(cursorLocation, "image", url);
        resetUploader();
      })
      .catch(err => {
        console.log(err);
      });
    }
  }
}
</script>
<style scoped lang="scss">
  .bootstrapComtain ::v-deep {
    @import "~bootstrap/dist/css/bootstrap.min";
  }
</style>
